module.exports = __webpack_public_path__ + "img/githubb.35cce7b4.png";